import { render, staticRenderFns } from "./VHeaderPrescriptionMenu.vue?vue&type=template&id=21343ba2&"
import script from "./VHeaderPrescriptionMenu.vue?vue&type=script&lang=ts&"
export * from "./VHeaderPrescriptionMenu.vue?vue&type=script&lang=ts&"
import style0 from "./VHeaderPrescriptionMenu.vue?vue&type=style&index=0&id=21343ba2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports